'use client';
var classes = {"root":"m-4451eb3a"};

export default classes;
//# sourceMappingURL=Center.module.mjs.map
